export default {
    OC: "口语点评",
    OCHome: " 点评首页",
    PC:"个人中心",
    BILL:"我的账单",
    RUlE:"派单规则"
    
}


// WEBPACK FOOTER //
// ./src/i18n/zh-CN/menu.js